import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [customNavPages, setCustomNavPages] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [s, p] = await Promise.all([
        api.get("/site/settings"),
        api.get("/pages", { params: { nav_only: true } }).catch(() => ({ data: { items: [] } })),
      ]);
      setSettings(s.data);
      setCustomNavPages(p.data.items || []);
    } catch (e) {
      // Fall back to defaults - context still functional with `settings=null` guarded via optional chaining
      console.warn("Site settings load failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SettingsContext.Provider value={{ settings, customNavPages, loading, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be inside SettingsProvider");
  return ctx;
}
